import React, { useEffect, useState } from 'react';
import LolViewSetPickPlayer from './player';
import style from './style.module.scss';

const LolViewSetPick = ({ players }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(players);
  }, [players]);

  return (
    <div className={style.pick}>
      {list.length > 0 && list.map((item, idx) => <LolViewSetPickPlayer item={item} key={`${idx}-${item.pid}`} />)}
    </div>
  );
};

export default LolViewSetPick;
